interface BenefitDescriptionOption {
  type: "dollarAmount" | "salaryMultiplier" | string;
  value: number;
}

export interface PopoverListField {
  key: string;
  label?: string;
  type?: "currency" | "percentage" | "number";
  min?: number;
  max?: number;
  placeholder?: string;
}

export const formatBenefitDescriptionOption = (
  option: BenefitDescriptionOption,
): string => {
  if (option.type === "dollarAmount") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(option.value);
  }
  if (option.type === "salaryMultiplier") {
    return `${option.value}x salary`;
  }
  return String(option.value);
};

export const formatPopoverListEntry = (
  entry: Record<string, unknown>,
  fields: PopoverListField[],
  renderFormat?: string,
): string => {
  if (!renderFormat) {
    const parts: string[] = [];
    fields.forEach((field) => {
      const fieldValue = entry[field.key];
      if (
        fieldValue !== undefined &&
        fieldValue !== null &&
        fieldValue !== ""
      ) {
        parts.push(String(fieldValue));
      }
    });
    return parts.join(" - ");
  }

  let result = renderFormat;
  const tokenPattern = /(\$XX,XXX|\$XX|XX%|XX)/g;
  const tokens: string[] = [];
  let match;
  while ((match = tokenPattern.exec(renderFormat)) !== null) {
    tokens.push(match[0]);
  }

  fields.forEach((field, index) => {
    if (index >= tokens.length) return;

    const value = entry[field.key];
    if (value === undefined || value === null || value === "") return;

    const num = typeof value === "string" ? parseFloat(value) : Number(value);
    if (isNaN(num)) return;

    const token = tokens[index];
    let formatted: string;

    if (token.startsWith("$")) {
      formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(num);
    } else if (token.includes("%")) {
      formatted = `${num}%`;
    } else {
      formatted = String(num);
    }

    result = result.replace(token, formatted);
  });

  return result;
};
